import { Container, Row } from 'reactstrap';
import NavbarComponent from '../../Components/Header/Navbar';
import React from 'react';
import error400cover from '../../assets/images/error400-cover.png';
import { useTrans } from '../../Components/Hooks/UserHooks';

const PageNotFound = () => {
    const t = useTrans('translation');
    return (
        <React.Fragment>
            <NavbarComponent language={undefined} languagesList={undefined} changeLanguages={undefined} />
            <Container>
                <Row className="justify-content-center page-content">
                    <div className="d-flex flex-column align-items-center justify-content-center ">
                        <div className="text-center ">
                            <img src={error400cover} alt="error img" className="img-fluid" />
                            <div className="mt-3">
                                <h3 className="text-uppercase">{t('pageNotFound')} 😎😎</h3>
                            </div>
                        </div>
                    </div>
                </Row>
            </Container>
        </React.Fragment>
    );
};
export default PageNotFound;
